import gql from 'graphql-tag';

const ShopOwnerQuery = gql`
  query ShopOwner($queryParams: String!) {
    shop(queryParams: $queryParams) {
      owner {
        email
        firstName
        lastName
      }
    }
  }
`;

export default ShopOwnerQuery;
